import { render, staticRenderFns } from "./ErrorDialog.component.vue?vue&type=template&id=6b47c3f2&scoped=true&"
import script from "./ErrorDialog.component.vue?vue&type=script&lang=ts&"
export * from "./ErrorDialog.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b47c3f2",
  null
  
)

export default component.exports